<template>
<van-actionsheet
    class="collab-sheet"
    v-model="show"
  >
  <van-nav-bar
    class="file-header nav-bar-bgcolor"
    :title="$t('collab.roles.choose')"
    :left-text="$t('base.cancel')"
    :right-text="!$route.query.invite && $t('base.save') || ''"
    @click-left="handleClose"
    @click-right="handleSave"
  />
  <div class="collab-collabItem-container">
    <div class="collab-roles-choose">
      {{$t('collab.roles.choose')}}
    </div>
    <van-cell v-for="(item, index) in Object.keys(collabLevelMessage)"
      :title="$t(collabLevelMessage[item])"
      :key="index"
      size="large"
      @click="handleActive(item)"
    >
      <svg-icon v-if="currentRoleLevel === item" cls="svg-active" icon="Selected1"/>
    </van-cell>
    <div class="collab-learn-roles" @click="handleShowRules(true)">
      {{$t('collab.learnRoles')}}
    </div>
    <div @click="handleShowRules(false)">
      <van-popup v-model="showLeanRoles" class="image-popup" position="bottom">
        <image-viewer
          :previewInfo="{
            download_url: downloadUrl,
            exif_rotation: 6
          }"
        />
      </van-popup>
    </div>
  </div>
</van-actionsheet>
</template>
<script>
import Vue from 'vue'
import {i18n} from '@/utils/i18n'
import {Cell} from 'vant'
import {deepCopy, loading, toast} from '@/utils/common'
import {COLLAB_EDIT} from '@/config/api'
import ajax from '@/utils/ajax'
import config from '@/config'
import ImageViewer from '../preview/ImageViewer'

Vue.use(Cell)

export default {
  name: 'collab',
  i18n,
  data () {
    return {
      show: false,
      currentRoleLevel: '',
      collabLevelMessage: {}, // 针对对当前用户权限的 权限选择列表
      showLeanRoles: false
    }
  },
  components: {
    ImageViewer
  },
  props: {
    collabItem: Object,
    headerItem: Object
  },
  computed: {
    downloadUrl () {
      const lang = {
        'zh-CN': '',
        'zh-TW': '-tw',
        'en': '-en'
      }

      if (![13, 25, 1, 23, 14, 27, 9].includes(config.enterprise_info.plan_id)) {
        return require(`@/assets/new-collabs-level-company${lang[this.$i18n.locale]}@2x.png`)
      } else {
        return require(`@/assets/collabs-level-company${lang[this.$i18n.locale]}@2x.png`)
      }
    }
  },
  watch: {
    $route (to, from) {
      const { collabLevel, invite } = to.query

      if (collabLevel) {
        const {roleMessage, currentRoleLevel} = this.store.collabState
        const {user: {is_group} = {}} = this.collabItem
        const {final_role} = this.headerItem
        const cloneMessage = deepCopy(roleMessage)

        delete cloneMessage.owner
        if (!invite && ((final_role !== 'owner') || is_group)) delete cloneMessage.coowner
        // 邀请协作权限选择页 (只有 'owner', 'coowner', 'editor'， 才能进入当前页面)
        // 共同所有者 能邀请编辑及以下
        // 编辑者 能邀请编辑及以下
        if (invite && !['owner'].includes(final_role)) {
          delete cloneMessage.owner
          delete cloneMessage.coowner
        } else {
          delete cloneMessage.owner
        }

        this.collabLevelMessage = cloneMessage
        this.currentRoleLevel = currentRoleLevel || this.collabItem.final_role
      }
      this.show = !!collabLevel
    }
  },
  methods: {
    handleActive (currentRoleLevel) {
      this.currentRoleLevel = currentRoleLevel
      if (this.$route.query.invite) this.handleSave()
    },
    handleClose () {
      this.toggleQuery('collabLevel')
    },
    handleSave () {
      const data = this.computeCollabLevel()

      if (this.$route.query.invite) {
        this.toggleQuery('collabLevel')
        this.setState({collabState: {...this.store.collabState, currentRoleLevel: this.currentRoleLevel}})
      } else {
        this.changeCollabLevel(data)
      }
    },
    computeCollabLevel () {
      const {collab_id, direct_role, is_group, user: {id} = {}} = this.collabItem
      const data = {item_id: this.headerItem.id}
      const role = this.currentRoleLevel

      if (direct_role) {
        data.edit_collabs_roles = []
        data.edit_collabs_roles.push({
          collab_id: Number(collab_id),
          role
        })
      } else {
        const dataKey = is_group ? 'invite_group_collabs_roles' : 'invite_user_collabs_roles'
        data[dataKey] = []
        data[dataKey].push({
          collab_id: Number(collab_id),
          role,
          user_id: id
        })
      }
      return data
    },
    changeCollabLevel (data) {
      const loadingStatus = loading()

      ajax({url: COLLAB_EDIT, data, method: 'POST'}).then((result = {}) => {
        this.setState({
          collabState: {
            ...this.store.collabState,
            currentRoleLevel: this.currentRoleLevel,
            refreshCollabList: new Date().getTime()
          }
        })
        loadingStatus.clear()
        !result.errors && toast.success(i18n.t('collab.change.success'))
        setTimeout(() => {
          this.toggleQuery('collabLevel')
        }, 600)
      })
    },
    handleShowRules (show) {
      this.showLeanRoles = show
    }
  }
}

</script>
<style lang="postcss">
.collab-sheet {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
  background-color: #eff2f6;

  & .collab-collabItem-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 16px;

    & .image-popup {
      width: 100%;
      height: 100%;

      & .preview-image-viewer {
        height: 100%;
        width: 100%;
        background-color: #000;

        & img {
          background-color: #fff;
        }
      }
    }

    & .collab-roles-choose {
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      color: #4B5255;
      padding-left: 15px;
      margin-top: 16px;
      margin-bottom: 6px;
    }
    & .collab-learn-roles {
      text-align: center;
      color: #6ca2ff;
      background-color: #fff;
      height: 44px;
      line-height: 44px;
      margin-top: 10px;
    }
    & .svg-active {
      height: 20px;
      width: 20px;
      position: absolute;
      right: 0;
      top: 2px;
    }
    & .van-cell__value {
      position: relative;
    }
    & .roles-detail {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      background-color: #000;
      & .img {
         transform: rotate(90deg);
      }
    }
  }
}
</style>
